import qbjsapi, { promiseAllSettled } from '@tencent/zixun-qbjsapi';
import C4PV from './C4PV';
import querystring from 'query-string';

function getParamFromQua(qua2, key) {
  if (!qua2) {
    return '';
  }
  let arr = qua2.split(`${key}=`);
  if (!arr[1]) {
    return '';
  }
  arr = arr[1].split('&');
  return arr[0];
}

export const getAccountInfo = qbjsapi?.login?.getAccountInfo;

let deivceInfo;

export async function initAllDeviceInfo() {
  const [
    browserParam = {},
    qimei,
    advertisingID,
    idfv,
    androidId,
    wifiInfo,
    connentType,
    imsi,
    imei,
    version,
    macAddress,
    appVersion,
    networkType,
  ] = await promiseAllSettled([
    qbjsapi.app.getBrowserParam(),
    qbjsapi.device.getQIMEI(),
    qbjsapi.app.getAdvertisingID(),
    qbjsapi.device.getIDFV(),
    qbjsapi.device.getAndroidID(),
    qbjsapi.device.getWifiInfo(),
    qbjsapi.connect.getType(),
    qbjsapi.device.getImsi(),
    qbjsapi.device.getIMEI(),
    qbjsapi.device.getVersion(),
    qbjsapi.device.getMacAddress(),
    qbjsapi.app.getAppVersion(),
    qbjsapi.vpn.getNetworkType(),
  ]);
  const platform = getParamFromQua(browserParam.qua, 'PL') ?? 'other';
  const phoneName = getParamFromQua(browserParam.qua, 'MO');

  deivceInfo = {
    appVersion: appVersion ?? '',
    network: networkType || 0,
    deviceId: idfv ?? (imsi instanceof Object ? imsi.imsi : imsi) ?? '',
    qua: browserParam.qua ?? '',
    guid: browserParam.guid ?? '',
    imei: (imei && imei.imei) ?? '',
    qimei: (qimei && qimei.QIMEI) ?? '',
    macAddr: (macAddress instanceof Object ? macAddress.mac : macAddress) ?? '',
    phoneType: browserParam.phone_type ?? '',
    manufacturer: browserParam.manufacturer ?? '',
    idfa: advertisingID ?? '',
    idfv: idfv ?? '',
    androidId: androidId ?? '',
    wifiMac: wifiInfo.mac ?? '',
    imsi: (imsi instanceof Object ? imsi.imsi : imsi) ?? '',
    osVersion: version ?? '',
    simulation: browserParam.simulation,
    isRoot: browserParam.is_root,
    wifiSsid: connentType.ssid ?? '',
    platform,
    // eslint-disable-next-line no-nested-ternary
    os: platform === 'IOS' ? 2 : platform === 'ADR' ? 1 : 0,
    phoneName,
  };
  return deivceInfo;
}

export async function getDeivceInfo() {
  return deivceInfo ? deivceInfo : initAllDeviceInfo();
}

export async function getPraiseDeviceInfo() {
  const deviceInfo = await getDeivceInfo();

  return {
    app_version: deviceInfo.appVersion,
    os: deviceInfo.os,
    network: deviceInfo.network,
    device_id: deviceInfo.deviceId,
    qua: deviceInfo.qua,
    guid: deviceInfo.guid,
    terminal_id: deviceInfo.imei,
    // eslint-disable-next-line no-nested-ternary
    terminal_type: deviceInfo.platform === 'IOS' ? '3' : deviceInfo.platform === 'ADR' ? '2' : '1',
    ext: {
      imei: deviceInfo.imei,
      qimei: deviceInfo.qimei,
      mac_addr: deviceInfo.macAddr,
      phone_type: deviceInfo.phoneType,
      manufacturer: deviceInfo.manufacturer,
      phone_name: deviceInfo.phoneName,
      idfa: deviceInfo.idfa,
      idfv: deviceInfo.idfv,
      android_id: deviceInfo.androidId,
      wifi_mac: deviceInfo.wifiMac,
      imsi: deviceInfo.imsi,
      os_version: deviceInfo.osVersion,
      simulation: deviceInfo.simulation,
      is_root: deviceInfo.isRoot,
      wifi_ssid: deviceInfo.wifiSsid,
    },
  };
}

export async function userData() {
  // eslint-disable-next-line new-cap
  userData = await C4PV();
  return userData;
}

/** 获取渠道包链接 */
export const getDownloadUrl = () => {
  const callfrom = querystring.parse(window.location.search).callfrom;
  const channelMap = {
    re_share: '1100122803',
    right_corner_share: '1100122802',
    weixin: '1100122804',
    pengyouquan: '1100122804',
    QQ: '1100122805',
    qzone: '1100122805',
  };
  const channel = channelMap[callfrom] || channelMap.re_share;
  return `https://mdc.html5.qq.com/directdown?app=qqbrowser&channel=${channel}`;
};
